import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Form, FormTextField, Button } from 'components/controls';
import useFieldChange from 'hooks/use-field-change';
import withContext from 'decorators/withContext';
import ContactUsContext from 'contexts/ContactUsContext';
import loc from 'sources/locale/loc';
import styles from './ContactUs.scss';

function ContactUs(props) {
  const { onSend, error, processing, result } = props;
  const { values, handleFieldChange } = useFieldChange({
    name: '',
    email: '',
    text: '',
  });

  const handleSend = () => {
    onSend(values);
  };

  if (result) {
    return (
      <div className={styles.successMessage}>
        {loc('contact-us-success-text')}
        <Link to={'/'}>{loc('go-to-home')}</Link>
      </div>
    );
  }

  return (
    <>
      <h2>{loc('contact-us-title')}</h2>

      <Form
        onSubmit={handleSend}
        onFieldChange={handleFieldChange}
        processing={processing}
        error={error}
        fieldValues={values}
      >
        <FormTextField
          label={loc('your-name-label')}
          fieldKey="name"
          className={styles.field}
        />
        <FormTextField
          label={loc('your-email-label')}
          className={styles.field}
          fieldKey="email"
        />
        <FormTextField
          label={loc('message-label')}
          className={styles.field}
          fieldKey="text"
          multiline
          rows={8}
        />
        <Button
          type="submit"
          variant="filled"
          color="primary"
          label={loc('send-message')}
          className={styles.submitButton}
        />
      </Form>
    </>
  );
}

ContactUs.propTypes = {
  onSend: PropTypes.func.isRequired,
};

export default withContext(ContactUsContext.Consumer)(ContactUs);



// WEBPACK FOOTER //
// ./src/components/StaticPages/ContactUs.jsx